// frontend/src/components/DocumentList.js

// import React from 'react';
// import axios from 'axios';
// import './../DocumentList.css';

// const DocumentList = ({ documentos, fetchDocuments }) => {

//     // Função para Assinar e Recusar (da etapa anterior)
//     const handleAction = (pedidoId, action) => {
//         const url = `http://127.0.0.1:8000/api/pedidos/${pedidoId}/${action}/`;
//         axios.post(url)
//             .then(response => {
//                 console.log(`Ação '${action}' executada com sucesso para o pedido ${pedidoId}`);
//                 fetchDocuments(); // Recarrega a lista
//             })
//             .catch(error => {
//                 console.error(`Erro ao executar a ação '${action}'`, error.response?.data || error);
//                 alert(`Não foi possível ${action} o documento.`);
//             });
//     };

//     const handleArchive = (docId) => {
//         const url = `http://127.0.0.1:8000/api/documentos/${docId}/arquivar/`;
//         axios.post(url)
//             .then(response => {
//                 alert(`Documento arquivado com sucesso! Link: ${response.data.drive_link}`);
//                 fetchDocuments();
//             })
//             .catch(error => {
//                 const errorMsg = error.response?.data?.error || 'Erro desconhecido ao arquivar.';
//                 console.error("Erro ao arquivar o documento", error.response);
//                 alert(`Falha ao arquivar: ${errorMsg}`);
//             });
//     };

//     return (
//         <table>
//             <thead>
//                 <tr>
//                     <th>Descrição</th>
//                     <th>Status / Ações</th>
//                     <th>Enviado por</th>
//                     <th>Área</th>
//                     <th>Assinantes</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 {documentos.map(doc => (
//                     <tr key={doc.id}>
//                         <td>{doc.descricao}</td>
//                         <td>
//                             {doc.status}
//                             {doc.is_archivable && (
//                                 <button onClick={() => handleArchive(doc.id)} className="btn-archive">
//                                     Arquivar
//                                 </button>
//                             )}
//                         </td>
//                         <td>{doc.servidor_que_enviou_nome || 'N/A'}</td>
//                         <td>{doc.area_envio}</td>
//                         <td>
//                             <ul>
//                                 {doc.pedidos_assinatura.map(pedido => (
//                                     <li key={pedido.id} className={`status-${pedido.status.toLowerCase()}`}>
//                                         {pedido.assinante_nome} - <strong>{pedido.status}</strong>
//                                         {pedido.status === 'PENDENTE' && (
//                                             <span className="action-buttons">
//                                                 <button onClick={() => handleAction(pedido.id, 'assinar')} className="btn-sign">Assinar</button>
//                                                 <button onClick={() => handleAction(pedido.id, 'recusar')} className="btn-refuse">Recusar</button>
//                                             </span>
//                                         )}
//                                     </li>
//                                 ))}
//                             </ul>
//                         </td>
//                     </tr>
//                 ))}
//             </tbody>
//         </table>
//     );
// };

// export default DocumentList;

// --- SUBSTITUA O CONTEÚDO DE DocumentList.js POR ESTE ---
import React from 'react';
import { Grid, Box, Typography, CircularProgress } from '@mui/material';
import DocumentCard from './DocumentCard';

const DocumentList = ({ documents, isLoading, onDelete }) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', p: 4 }}>
        <Typography variant="h6" color="text.secondary">
          Nenhum documento em processo de assinatura encontrado.
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {documents.map(doc => (
        <Grid item xs={12} sm={6} md={4} key={doc.id}>
          <DocumentCard document={doc} onDelete={onDelete} />
        </Grid>
      ))}
    </Grid>
  );
};

export default DocumentList;